class CodingactivityController {
  constructor(
    $http,
    $scope,
    DTOptionsBuilder,
    DTColumnBuilder,
    USER,
    Constants,
    CONST,
    materialButtons,
    datePicker,
    CareType,
    $rootScope,
    FunctionService
  ) {
    $http.defaults.headers.common["Authorization"] =
      "Bearer " + $rootScope.globals.currentUser.token;
    this.user = USER;
    this.name = "Coding Activity Report";
    this.episodeValue = "";
    this.episodeValue = "";
    this.locale = "en-au";
    this.url =
      WEBSERVICEURL + "/dataagility/api/service.codingactivity/codingactivity";
    this.dtInstance = {};
    this.monthOptions = [];
    this.selectedMonth = undefined;
    this.fyOptions = [];
    this.selectedFy = undefined;
    $scope.promise = CareType.data().then(function (data) {
      $scope.vm.careTypeOptions = data;
    });
    this.selectedCareType = [];
    this.campusOptions = [];
    this.selectedCampus = [];

    this.dateTypeOptions = [{ id: 0, value: "Original Coding Date" }];
    this.dateType = this.dateTypeOptions[0];

    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(
      function (response) {
        $scope.vm.episodeValue =
          response.functionSettings.EpisodeValue.valueString;
        $scope.vm.functionSettings = response.functionSettings;

        $scope.vm.separationString =
          response.functionSettings.SeparationString.valueString;

        // All Private Clients should be active, All Public should be inactive
        if ($scope.vm.episodeValue === "$") {
          console.log("WIES vars set to private");
          $scope.vm.wiesDefault = "0.00";
          $scope.vm.wiesParseAmount = 2;
        } else {
          console.log("WIES vars set to public");
          $scope.vm.wiesDefault = "0.0000";
          $scope.vm.wiesParseAmount = 4;
        }

        const option = { id: 1, value: $scope.vm.separationString + " Date" };
        $scope.vm.dateTypeOptions.push(option);
        $scope.vm.dateType = $scope.vm.dateTypeOptions[1];

        Constants.campusData().then(function successCallback(response) {
          if (
            $scope.vm.user.role !== "Administrator" &&
            $scope.vm.functionSettings.LimitCampusDropDown &&
            $scope.vm.functionSettings.LimitCampusDropDown.isActive
          ) {
            let campusOptions = [];
            if (typeof $scope.vm.user.campus === "string") {
              campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
            } else {
              campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
            }
            $scope.vm.campusOptions = campusOptions;
            $scope.vm.selectedCampus = campusOptions;
          } else {
            $scope.vm.campusOptions = response;
          }
          filterCampus($scope.vm.campusOptions);
        });
      }
    );

    this.startDate = {
      input: {
        date: moment().locale(this.locale).subtract(2, "days"),
        dateFormatted: moment()
          .locale(this.locale)
          .subtract(2, "days")
          .format("L"),
      },
    };
    this.endDate = {
      input: {
        date: moment().locale(this.locale).subtract(1, "days"),
        dateFormatted: moment()
          .locale(this.locale)
          .subtract(1, "days")
          .format("L"),
      },
    };

    this.dischargeDateFromPicker = {
      input: {
        date: moment()
          .locale(this.locale)
          .subtract(60, "days")
          .startOf("month"),
        dateFormatted: moment()
          .locale(this.locale)
          .subtract(60, "days")
          .startOf("month")
          .format("L"),
      },
    };

    this.dischargeDateEndPicker = {
      input: {
        date: moment().locale(this.locale).subtract(1, "days"),
        dateFormatted: moment()
          .locale(this.locale)
          .subtract(1, "days")
          .format("L"),
      },
    };

    datePicker.autoClose($scope);

    initDropdowns();

    materialButtons.render();

    materialButtons.processing();

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption("ajax", {
        headers: {
          Authorization: "Bearer " + $rootScope.globals.currentUser.token,
        },
        url: $scope.vm.url,
        type: "GET",
        data: function (d) {
          (d.dateType = $scope.vm.dateType.id),
            (d.startDate = $scope.vm.startDate.input.dateFormatted),
            (d.endDate = $scope.vm.endDate.input.dateFormatted),
            (d.campus = $scope.vm.selectedCampus.join()),
            (d.careType = formatCareTypeParam());
        },
        error: (xhr, error, thrown) => {
          if (thrown == "Unauthorized") {
            //window.location.replace(window.location.origin + '/login');
            console.log(
              "Unauthorized request with token: ",
              $rootScope.globals.currentUser.token
            );
          }
        },
      })
      .withDataProp("data")
      .withOption("processing", true)
      .withOption("sAjaxDataProp", "")
      .withPaginationType("simple_numbers")
      .withOption("aaSorting", [[0, "asc"]])
      .withOption("dom", '<"wrapper"rt<"table-footer"iBp>>')
      .withOption("scrollY", "300px")
      .withOption("scrollX", "auto")
      .withOption(
        "initComplete",
        function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          // Update column headers even when no data returned
          setDtHeaders();
        }
      )
      .withOption("rowCallback", function (row, data, index) {
        // Update column headers if data returned
        setDtHeaders();
      })
      .withButtons([
        {
          extend: "print",
          text: "",
        },
        {
          extend: "csvHtml5",
          text: "",
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm"),
        },
        {
          extend: "excelHtml5",
          text: "",
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm"),
        },
        {
          text: "",
          action: function (e, dt, node, config) {
            dt.ajax.reload();
          },
        },
      ]);

    this.dtColumns = [
      DTColumnBuilder.newColumn("coder")
        .withTitle("Coder")
        .withClass("mdl-data-table__cell--non-numeric")
        .withOption("defaultContent", ""),
      DTColumnBuilder.newColumn("sameDayEpisodes")
        .withTitle("Same Day<br>Episodes")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", ""),
      DTColumnBuilder.newColumn("sameDayWies")
        .withTitle("Loading...")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", "")
        .renderWith(function (data, type, full) {
          return parseFloat(data).toFixed($scope.vm.fixedValue);
        }),
      DTColumnBuilder.newColumn("overnightEpisodes")
        .withTitle("Overnight<br>Episodes")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", ""),
      DTColumnBuilder.newColumn("overnightWies")
        .withTitle("Loading...")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", "")
        .renderWith(function (data, type, full) {
          return parseFloat(data).toFixed($scope.vm.fixedValue);
        }),
      DTColumnBuilder.newColumn("multidayEpisodes")
        .withTitle("Multiday<br>Episodes")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", ""),
      DTColumnBuilder.newColumn("multidayWies")
        .withTitle("Loading...")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", "")
        .renderWith(function (data, type, full) {
          return parseFloat(data).toFixed($scope.vm.fixedValue);
        }),
      DTColumnBuilder.newColumn("multidayLos")
        .withTitle("Multiday<br>LOS")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", ""),
      DTColumnBuilder.newColumn("multidayAverageLos")
        .withTitle("Multiday<br>Avg LOS")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", ""),
      DTColumnBuilder.newColumn("totalEpisodes")
        .withTitle("Total<br>Episodes")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", ""),
      DTColumnBuilder.newColumn("totalWies")
        .withTitle("Loading...")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", "")
        .renderWith(function (data, type, full) {
          return parseFloat(data)
            ? parseFloat(data).toFixed($scope.vm.wiesParseAmount)
            : $scope.vm.wiesDefault;
        }),
      DTColumnBuilder.newColumn("totalDays")
        .withTitle("Total<br>LOS")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", ""),
      DTColumnBuilder.newColumn("totalNumCodes")
        .withTitle("Total No.<br>Codes")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", ""),
      DTColumnBuilder.newColumn("codedPerHour")
        .withTitle("Coded<br>Per Hour")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", ""),
      DTColumnBuilder.newColumn("wiesPerHour")
        .withTitle("Loading...")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", "")
        .renderWith(function (data, type, full) {
          return parseFloat(data)
            ? parseFloat(data).toFixed($scope.vm.wiesParseAmount)
            : $scope.vm.wiesDefault;
        }),

      DTColumnBuilder.newColumn("percentSameDayOvernight")
        .withTitle("Same Day/Overnight<br>Episodes Percent")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", "")
        .renderWith(function (data, type, full) {
          return parseFloat(data).toFixed(2) + "%";
        }),
      DTColumnBuilder.newColumn("percentMultiday")
        .withTitle("Multiday<br>Episodes Percent")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", "")
        .renderWith(function (data, type, full) {
          return parseFloat(data).toFixed(2) + "%";
        }),

      DTColumnBuilder.newColumn("totalNumCodesPerHour")
        .withTitle("Total Codes<br>Per Hour")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", ""),
      DTColumnBuilder.newColumn("codingHours")
        .withTitle("Coding<br>Hours")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", ""),
      DTColumnBuilder.newColumn("queriesGenerated")
        .withTitle("Queries<br>Generated")
        .withClass("mdl-data-table__cell")
        .withOption("defaultContent", ""),
      //,
      // DTColumnBuilder.newColumn('auditingHours').withTitle('Auditing<br>Hours').withClass('mdl-data-table__cell').withOption('defaultContent', ''),
      // DTColumnBuilder.newColumn('queryHours').withTitle('Query<br>Hours').withClass('mdl-data-table__cell').withOption('defaultContent', ''),
      // DTColumnBuilder.newColumn('meetingHours').withTitle('Meeting<br>Hours').withClass('mdl-data-table__cell').withOption('defaultContent', ''),
      // DTColumnBuilder.newColumn('trainingHours').withTitle('Training<br>Hours').withClass('mdl-data-table__cell').withOption('defaultContent', ''),
      // DTColumnBuilder.newColumn('adminHours').withTitle('Administration<br>Hours').withClass('mdl-data-table__cell').withOption('defaultContent', ''),
      // DTColumnBuilder.newColumn('followupHours').withTitle('Follow-up<br>Hours').withClass('mdl-data-table__cell').withOption('defaultContent', ''),
      // DTColumnBuilder.newColumn('itHours').withTitle('IT<br>Hours').withClass('mdl-data-table__cell').withOption('defaultContent', ''),
      // DTColumnBuilder.newColumn('ualHours').withTitle('UAL<br>Hours').withClass('mdl-data-table__cell').withOption('defaultContent', ''),
      // DTColumnBuilder.newColumn('projectHours').withTitle('Project<br>Hours').withClass('mdl-data-table__cell').withOption('defaultContent', ''),
      // DTColumnBuilder.newColumn('reportHours').withTitle('Report<br>Hours').withClass('mdl-data-table__cell').withOption('defaultContent', ''),
      // DTColumnBuilder.newColumn('eduHours').withTitle('Education<br>Hours').withClass('mdl-data-table__cell').withOption('defaultContent', ''),
      // DTColumnBuilder.newColumn('otherHours').withTitle('Other<br>Hours').withClass('mdl-data-table__cell').withOption('defaultContent', '')
    ];

    function setDtHeaders() {
      $(
        $("#auditTable")
          .DataTable()
          .column(getIndexOfColumn("sameDayWies"))
          .header()
      ).html("Same Day<br>" + $scope.vm.episodeValue);
      $(
        $("#auditTable")
          .DataTable()
          .column(getIndexOfColumn("overnightWies"))
          .header()
      ).html("Overnight<br>" + $scope.vm.episodeValue);
      $(
        $("#auditTable")
          .DataTable()
          .column(getIndexOfColumn("multidayWies"))
          .header()
      ).html("Multiday<br>" + $scope.vm.episodeValue);
      $(
        $("#auditTable")
          .DataTable()
          .column(getIndexOfColumn("totalWies"))
          .header()
      ).html("Total<br>" + $scope.vm.episodeValue);
      $(
        $("#auditTable")
          .DataTable()
          .column(getIndexOfColumn("wiesPerHour"))
          .header()
      ).html($scope.vm.episodeValue + "<br>Per Hour");
    }

    function getIndexOfColumn(columnName) {
      const selectedColumn = $scope.vm.dtColumns.filter(
        (x) => x.mData === columnName
      );
      return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
    }

    function initDropdowns() {
      // Order the months in the dropdown from July to June
      for (var i = 6; i < 12; i++) {
        // July to December
        $scope.vm.monthOptions.push(moment.months(i));
      }

      for (var i = 0; i < 6; i++) {
        // January to June
        $scope.vm.monthOptions.push(moment.months(i));
      }

      $scope.vm.selectedMonth = moment().format("MMMM"); // Default to current month

      // Format the financial year dropdown values
      if (moment().month() < 6) {
        var year = moment().format("YYYY");
      } else {
        var year = moment().add(1, "year").format("YYYY");
      }

      for (var i = 0; i < 2; i++) {
        // Current finanical year, then the previous one
        $scope.vm.fyOptions.push(year - 1 + " - " + year);
        year--;
      }

      $scope.vm.selectedFy = $scope.vm.fyOptions[0]; // Default to current financial year
    }

    // Respond to user selection
    // re-draw table on datepicker close
    $scope.$on("lx-date-picker__close-start", function (e, id) {
      var table = $("#auditTable").DataTable();
      table.ajax.url($scope.vm.url).load().draw();
    });

    this.setDateType = setDateType;

    function setDateType(newValue) {
      $scope.vm.dateType = newValue;
      $scope.vm.selectedDateTypeId = newValue.id;
      $scope.vm.selectedDateTypeValue = newValue.value;
      $scope.vm.reloadData();
    }

    this.setMonth = setMonth;

    function setMonth(newValue) {
      $scope.vm.selectedMonth = newValue;
      reloadData();
    }

    this.setYear = setYear;

    function setYear(newValue) {
      $scope.vm.selectedFy = newValue;
      reloadData();
    }

    this.setCampus = setCampus;

    function setCampus(newValue) {
      $scope.vm.selectedCampus = newValue;
      reloadData();
    }

    this.setCareType = setCareType;

    function setCareType(newValue) {
      $scope.vm.selectedCareType = newValue;
      reloadData();
    }

    this.reloadData = reloadData;

    function reloadData() {
      $scope.vm.dtInstance.reloadData();
    }

    // Get the care type codes rather than send the descriptions
    this.formatCareTypeParam = formatCareTypeParam;

    function formatCareTypeParam() {
      let codes = [];

      if ($scope.vm.selectedCareType.length !== 0) {
        angular.forEach($scope.vm.selectedCareType, function (value, key) {
          codes.push(value.code);
        });

        return codes.join();
      } else {
        return "";
      }
    }

    // Plus/minus functionality for filters
    function filterCareType(modifier) {
      if ($scope.vm.careType) {
        $scope.vm.careType.selectedCareType = []; // In case minus was clicked

        if (modifier === "add") {
          // If minus wasn't clicked, assign all the values
          $scope.vm.careType.selectedCareType = CONST.CARETYPE;
        }
      }
    }

    function filterCampus(modifier) {
      if ($scope.vm.campus) {
        $scope.vm.campus.selectedCampus = []; // In case minus was clicked

        if (modifier === "add") {
          $scope.vm.campus.selectedCampus = $scope.vm.campusOptions; // If minus wasn't clicked, assign all the values
        }
      }
    }

    // Call the appropriate function to add/remove values
    this.filterSwap = filterSwap;

    function filterSwap(filter, modifier) {
      switch (filter) {
        case "careType":
          filterCareType(modifier);
          break;

        case "campus":
          filterCampus(modifier);
          break;
        case "startDate":
          $scope.vm.startDate.input.date = null;
          $scope.vm.startDate.input.dateFormatted = null;
          break;

        case "endDate":
          $scope.vm.endDate.input.date = null;
          $scope.vm.endDate.input.dateFormatted = null;
          break;

        case "dischargeDateFrom":
          $scope.vm.dischargeDateFromPicker.input.date = null;
          $scope.vm.dischargeDateFromPicker.input.dateFormatted = null;
          break;

        case "dischargeDateEnd":
          $scope.vm.dischargeDateEndPicker.input.date = null;
          $scope.vm.dischargeDateEndPicker.input.dateFormatted = null;
          break;
        default:
          break;
      }
    }
  }
}

export default CodingactivityController;



// WEBPACK FOOTER //
// ./client/app/common/reports/codingactivity/codingactivity.controller.js